import React from "react";
import { htmlDecode } from "../../utils";

class QuestionnaireText extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <>
                { window.images.questionnaireText && window.images.questionnaireImage &&
                    <div className="row justify-content-md-center">
                        <div className="col-12 col-sm-4 col-md-4 col-lg-3 p-5">
                            <img className="img-responsive" src={window.images.questionnaireImage} />
                        </div>
                        <div className="col-12 col-sm-8 col-md-6 col-lg-6 p-5">
                            <div className="vertical-center" dangerouslySetInnerHTML={{__html: htmlDecode(window.images.questionnaireText)}}></div>
                        </div>
                    </div>
                }
            </>
        )
    }
}

export default QuestionnaireText



